'use client';

import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';
import { openLeasinglLeadModalAtom } from '@core/Atoms/LeasingModal/LeasingModal.atom';

export const LeasingPageLeads = () => {
  const canOpenLeasinglLeadModal = useAtomValue(openLeasinglLeadModalAtom);
  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  useEffect(() => {
    if (canOpenLeasinglLeadModal) {
      toggleLeadForm('leasing-online');
    }
  }, [canOpenLeasinglLeadModal]);

  return null;
};
